module.exports = __webpack_public_path__ + "img/42.52a31bf5.webp";